(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Map();
  const revealSelectors = [
    '.opd__details',
    '.opd__custom',
    '.opd__faq',
    '.opd__related',
    '.oc__hero > *',
    '.oc__toolbar',
    '.oc__card',
    '.oc__description',
  ];

  const makeVisible = (element) => element.classList.add('is-visible');

  const initializeReveals = (root) => {
    const elements = Array.from(root.querySelectorAll(revealSelectors.join(',')));
    if (!elements.length) return;

    const groups = new Map();
    elements.forEach((element) => {
      const bounds = element.getBoundingClientRect();
      if (bounds.top < window.innerHeight && bounds.bottom > 0) element.classList.add('catalog-first-paint', 'is-visible');
      const group = element.parentElement;
      const index = groups.get(group) || 0;
      groups.set(group, index + 1);
      element.classList.add('catalog-reveal');
      element.style.setProperty('--catalog-delay', `${Math.min(index * 80, 400)}ms`);
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach(makeVisible);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          makeVisible(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    elements.forEach((element) => observer.observe(element));
    observers.set(root, observer);
  };

  const initializeProduct = (root) => {
    const product = root.matches?.('.opd') ? root : root.querySelector?.('.opd');
    if (!product) return;

    const gallery = product.querySelector('.opd__gallery');
    const info = product.querySelector('.opd__info');
    info?.querySelectorAll(':scope > *').forEach((element, index) => {
      element.style.setProperty('--catalog-info-delay', `${180 + Math.min(index * 75, 525)}ms`);
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        gallery?.classList.add('is-visible');
        info?.classList.add('is-visible');
      });
    });

    product.addEventListener('click', (event) => {
      const thumb = event.target.closest('.opd__thumbs button');
      if (thumb) {
        requestAnimationFrame(() => {
          const active = product.querySelector('.opd__slide.is-active');
          active?.classList.add('is-media-entering');
          window.setTimeout(() => active?.classList.remove('is-media-entering'), 700);
        });
        return;
      }

      const mainMedia = event.target.closest('.opd__main-media');
      if (!mainMedia || window.matchMedia('(max-width: 749px)').matches) return;
      const image = mainMedia.querySelector('.opd__slide.is-active img');
      if (!image) return;

      let dialog = document.querySelector('.catalog-lightbox');
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.className = 'catalog-lightbox';
        dialog.innerHTML = '<button class="catalog-lightbox__close" type="button" aria-label="Close">×</button><img alt="">';
        dialog.querySelector('button').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (dialogEvent) => {
          if (dialogEvent.target === dialog) dialog.close();
        });
        document.body.append(dialog);
      }

      const dialogImage = dialog.querySelector('img');
      dialogImage.src = image.currentSrc || image.src;
      dialogImage.alt = image.alt;
      dialog.showModal();
    });
  };

  const initializeCollection = (root) => {
    const collection = root.matches?.('.oc') ? root : root.querySelector?.('.oc');
    if (!collection) return;

    collection.addEventListener(
      'change',
      (event) => {
        if (!event.target.matches('select[name="sort_by"]')) return;
        document.documentElement.classList.add('catalog-is-leaving');
      },
      { capture: true }
    );

    collection.addEventListener(
      'submit',
      () => document.documentElement.classList.add('catalog-is-leaving'),
      { capture: true }
    );
  };

  const initialize = (root = document) => {
    document.documentElement.classList.add('catalog-motion-ready');
    initializeProduct(root);
    initializeCollection(root);
    initializeReveals(root);
  };

  const destroy = (root) => {
    observers.get(root)?.disconnect();
    observers.delete(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
